import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  TablePagination,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";
import { useSelector } from "react-redux";
import configServ from "../../services/config";

const PermissionsTable = ({
  data,
  search,
  page,
  rowsPerPage,
  total,
  loading,
  setSearch,
  setPage,
  setRowsPerPage,
}) => {
  const { user_id, company_id, is_super, is_admin } = useSelector(
    (state) => state.GlobalVariables
  );

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(0); // Reset to first page on search
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        padding: 3,
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: "darkblue",
          mb: 2,
          textAlign: "center", // This centers the text
        }}
      >
        Permissions Table
      </Typography>

      {/* Search Box */}
      <Box display="flex" justifyContent="flex-end" mb={3}>
        <TextField
          size="small"
          label="Search by Name"
          value={search}
          onChange={handleSearchChange}
          variant="outlined"
          sx={{ width: "300px" }}
        />
      </Box>

      {/* Loader */}
      {loading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: 150 }}
        >
          <CircularProgress />
        </Box>
      )}

      {/* Content */}
      {!loading && (
        <>
          {/* No Data Found */}
          {data.length === 0 ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                height: 150,
                color: "red",
                fontWeight: "bold",
                fontSize: "1.2rem",
              }}
            >
              No Data Found
            </Box>
          ) : (
            <>
              {/* Table */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <TableContainer
                  component={Paper}
                  elevation={3}
                  sx={{ width: "100%", overflowX: "auto" }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: "skyblue",
                            fontWeight: "bold",
                          }}
                        >
                          S.No.
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "skyblue",
                            fontWeight: "bold",
                          }}
                        >
                          Customer Name
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: "skyblue",
                            fontWeight: "bold",
                          }}
                        >
                          Permission
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell>{row.user_name}</TableCell>
                          <TableCell>{row.role_name}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </motion.div>

              {/* Pagination */}
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default PermissionsTable;
